import { RouteType } from "types/RouteType";

const dataExportRoute: RouteType = {
  name: "DataExport",
  title: "Data Export",
  path: "/admin/data-export",
  layout: "/admin",
  viewportCard: {
    header: {
      enableBackButton: true,
      title: "Data Export",
      enableRefreshButton: true,
      color: "primary",
      component: () => import("./DataExport.Header"),
    },
    body: {
      component: () => import("./DataExport.Body"),
      grayBackground: false,
    },
  },
  group: "Admin",
  searchAliases: ["csv", "download"],
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
};

export default dataExportRoute;
